<template>
    <div class="notifications notifications--overview loading-wrapper" :class="{ 'is-loading' : loading }">
        <div class="loading-message">{{ this.$t('results_loading') }}</div>
        <template v-if="notificationsCount === 0">
            <div class="notifications--overview__empty-item">
                {{ $t('notifications.no_results_found') }}
            </div>
        </template>
        <template v-else v-for="item in notifications">
            <div class="notifications--overview__item">
                <router-link :to="item.route" :title="item.title">
                    <h2>{{ item.title }}</h2>
                    <p>{{ item.description }}</p>
                </router-link>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading             : false,
                notifications       : [],
                notificationsCount  : 0
            };
        },
        created : function () {
            this.onUpdateNotifications();
        },
        methods : {
            onUpdateNotifications : function () {
                let promise = this.$api.clearParams()
                    .setPageParams(1, 5)
                    .get('notifications');

                promise.then((response => {
                    var items = [];

                    response.data.data.forEach((function (item) {
                        var type = item.entity.split('\\').pop().toLowerCase();

                        if (type === 'project') {
                            items.push({
                                title       : this.$t('home.notifications.project_' + item.event, {
                                    project_number  : item.object.data.project_number,
                                }),
                                description : this.$t('home.notifications.project_' + item.event + '.desc', {
                                    project_number  : item.object.data.project_number,
                                    company         : item.object.data.location.company_name
                                }),
                                route       : { name : 'customers-view-customer-project', params : { customer : item.customer_id, project : item.entityId } }
                            })
                        }
                    }).bind(this));

                    this.notifications      = items;
                    this.notificationsCount = items.length;

                    this.loading            = false;
                }).bind(this)).catch((error => {
                    this.notifications      = [];
                    this.notificationsCount = 0;

                    this.loading            = false;
                }).bind(this));

                this.loading = true;
            }
        }
    }
</script>